var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:none}.b{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m-5-5h36v36h-36z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m22.8 16.8c-0.7 1.9-2.1 3.6-3.8 4.9-1.8 1.2-3.9 1.8-6 1.8-2.1 0-4.2-0.6-6-1.8-1.7-1.3-3.1-3-3.8-5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m3.2 9.3c0.7-2 2.1-3.7 3.8-5 1.8-1.2 3.9-1.8 6-1.8 2.1 0 4.2 0.6 6 1.8 1.7 1.3 3.1 3 3.8 5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m3.2 9.3l19.6-0.1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m3.2 16.8l19.6-0.1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m1 11.5l1.5 3 1.5-3 1.5 3 1.5-3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m10 11.5l1.5 3 1.5-3 1.5 3 1.5-3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m19 11.5l1.5 3 1.5-3 1.5 3 1.5-3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m17 9.3q-0.2-1-0.6-1.9-0.4-1-0.9-1.8-0.5-0.9-1.1-1.6-0.7-0.8-1.4-1.5-0.7 0.7-1.4 1.4-0.6 0.8-1.1 1.7-0.5 0.8-0.9 1.7-0.4 0.9-0.6 1.9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m9 16.8q0.2 0.9 0.6 1.8 0.4 1 0.9 1.8 0.5 0.9 1.1 1.6 0.7 0.8 1.4 1.5 0.7-0.7 1.4-1.5 0.6-0.7 1.1-1.6 0.5-0.8 0.9-1.8 0.4-0.9 0.6-1.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWebsite);
export default __webpack_public_path__ + "static/media/icon-website.9d8e9577ff0524d003d9db1e761828d9.svg";
export { ForwardRef as ReactComponent };